import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

const FAQ_ITEMS = [
  ["How can I track my order?", "Once your order ships, we will send tracking details to the email or phone number used at checkout. If the message does not arrive, contact cost@averlynxstore.one with your order number."],
  ["Can I change or cancel an order?", "Contact us as soon as possible. We cannot guarantee changes after fulfillment begins, but we will help where we can."],
  ["Which payment methods are accepted?", "The payment methods currently available are shown at checkout. Availability may depend on your location and payment provider."],
  ["How do I choose a size?", "Use the size options and fit notes on each product page. For additional measurements, email our customer care team before ordering."],
  ["How long does delivery take?", "Delivery times vary by destination and service. Review the Shipping page for current estimates; customs delays may affect international orders."],
  ["What is the return process?", "Review the Returns & Exchanges page before sending an item back. Items must meet the listed condition and return-window requirements."],
  ["How should I care for my item?", "Follow the care information on the product page and the garment label. When the two differ, the physical care label controls."],
  ["Are product colours exact?", "We aim to show colours accurately, but displays and lighting can create small differences. Product construction may also vary slightly by production run."],
  ["How do I contact averlynxstore?", "Email cost@averlynxstore.one. You can also use the Contact Us form, and we will respond as soon as reasonably possible."],
];

function FAQs() {
  return (
    <div className="privacy">
      <Header />
      <main id="MainContent">
        <div id="cms-content">
          <div>
            <h3><span>Frequently Asked Questions</span></h3>
            <p className="MsoNormal"><strong><u>Last Updated: September 9, 2026</u></strong></p>
            <p className="MsoNormal">These answers provide general guidance about shopping with averlynxstore. Order-specific questions should be sent to <a href="mailto:cost@averlynxstore.one">cost@averlynxstore.one</a>.</p>
            {FAQ_ITEMS.map(([question, answer]) => (
              <section key={question}>
                <h3><span>{question}</span></h3>
                <p className="MsoNormal">{answer}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default FAQs;
